export default __webpack_public_path__ + "static/media/ic-recharge-stop.9c4501ff.svg";